export default __webpack_public_path__ + "static/media/error_page_404.5e71863d.png";